import {FilterSign, FilterSignText, Sign} from './reports.interfaces';

export const NUMBER_SIGNS: Sign[] = [
  {
    value: FilterSign.GT,
    display: '>',
    text: FilterSignText.GT
  },
  {
    value: FilterSign.LT,
    display: '<',
    text: FilterSignText.LT
  },
  {
    value: FilterSign.GTE,
    display: '≥',
    text: FilterSignText.GTE
  },
  {
    value: FilterSign.LTE,
    display: '≤',
    text: FilterSignText.LTE
  }
];

export const COMMON_SIGNS: Sign[] = [
  {
    value: FilterSign.EQ,
    display: '=',
    text: FilterSignText.EQ
  },
  {
    value: FilterSign.NE,
    display: '≠',
    text: FilterSignText.NE
  }
];

export const STRING_SIGNS: Sign[] = [
  {
    value: FilterSign.BEGINS_WITH,
    display: 'x*',
    text: FilterSignText.BEGINS_WITH
  },
  {
    value: FilterSign.ENDS_WITH,
    display: '*x',
    text: FilterSignText.ENDS_WITH
  },
  {
    value: FilterSign.CONTAINS,
    display: '*x*',
    text: FilterSignText.CONTAINS
  },
  {
    value: FilterSign.NOT_CONTAINS,
    display: '*ø*',
    text: FilterSignText.NOT_CONTAINS
  }
];

interface EmptySignConfig {
  value: FilterSign;
  text: FilterSignText;
  display: string;
  symbolDisplay: string;
}

const EMPTY_SIGN_CONFIGS: EmptySignConfig[] = [
  {
    value: FilterSign.EM,
    text: FilterSignText.EM,
    display: 'TEMPLATE.is_empty',
    symbolDisplay: '∅'
  },
  {
    value: FilterSign.NEM,
    text: FilterSignText.NEM,
    display: 'TEMPLATE.is_not_empty',
    symbolDisplay: '≠∅'
  }
];

export const EMPTY_SIGNS: Sign[] = EMPTY_SIGN_CONFIGS.map(({value, display, text}) => ({
  value,
  display,
  text
}));

export const EMPTY_SIGNS_WITH_SYMBOL: Sign[] = EMPTY_SIGN_CONFIGS.map(({value, symbolDisplay, text}) => ({
  value,
  display: symbolDisplay,
  text: text === FilterSignText.EM ? FilterSignText.EMPTY : FilterSignText.NOT_EMPTY
}));

